/* eslint-disable no-use-before-define */
import React from 'react'
import { useOrderTicket, } from '../use-order-ticket.js'
import { viewBack, safeURL, openWindow, show } from '../../twd'

export const Buttons = () => {

    const {
        previewTicket, from, isRfq, isTreasuryAuction
    } = useOrderTicket()

    const label = isRfq && !isTreasuryAuction
        ? 'Preview quote request'
        : 'Preview order'

    return <React.Fragment>
        <button
            data-name="order-ticket-back-button"
            className="btn btn-primary-outline"
            onClick={() => {

                if (!from || from==='order-ticket') {
                    show('overview')
                    return
                }

                let u = safeURL(from)
                if (u) {
                    openWindow(u.toString())
                    return
                }

                viewBack()
            }}
        >Back</button>

        <Sep />

        <button
            className="btn btn-primary"
            onClick={() => {
                previewTicket()
            }}
        >{label}</button>
    </React.Fragment>
}


const Sep = () => <span aria-hidden={true} style={{padding:'0 0 0 10px'}}></span>


// WEBPACK FOOTER //
// ./src/order-ticket/form/buttons.js